import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  return {
    root: {
      borderBottom: "thin solid",
      borderBottomColor: theme.palette.divider,
      paddingBottom: 5
    },
    title: {

    },
    staticBar: {
      position: "relative",
      cursor: "pointer",
      "&:hover": {
        background: theme.palette.action.hover
      }
    },
    icon: {
      position: "absolute",
      top: "50%",
      right: theme.spacing(1),
      transform: "translateY(-50%)"
    },
    membersRoot: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "flex-start",
      alignItems: "center"
    },
    chipUser: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1)
    },
    divider: {
      width: theme.spacing(1)
    },
    avatar: {
      height: 25,
      marginRight: theme.spacing(1)
    }
  }
});
